import { AgencyActionResult } from '../models/agency-action-result.models';
import { Category } from '../models/agency-category.models';
import { AgencyDetails, AgencySettings } from '../models/agency-details.models';

export const AGENCY_DETAILS_STORE_KEY = 'agency-details';

export interface IAgencyDetailsState {
  uid: string | null;
  currentAgency: AgencyDetails | null;
  categoriesList: Category[];
  settings: AgencySettings | null;
  isLoading: boolean;
  actionResult: AgencyActionResult | null;
  isImageLoading: boolean;
}

export const initialState: IAgencyDetailsState = {
  uid: null,
  currentAgency: null,
  categoriesList: [],
  settings: null,
  isLoading: false,
  actionResult: null,
  isImageLoading: false,
};
